export default __webpack_public_path__ + "static/media/casal_2.ae67e9cc.jpg";